(function(root){
 'use strict';
 const LANGS=['fr','nl','en'];
 const allowed=c=>String(c.themeId)==='196759880006'&&['unpublished','main'].includes(c.themeRole)&&c.pageType==='product'&&LANGS.includes(c.language)&&/^\d+$/.test(c.productId);
 const key=f=>f.resource_id+'|'+f.resource_key;
 async function fetchRetry(fetchJSON,url,wait=ms=>new Promise(resolve=>setTimeout(resolve,ms))){
  for(let attempt=0;;attempt++)try{return await fetchJSON(url);}catch(error){
   const transient=error instanceof TypeError||/^(Bundle|Title) HTTP (500|502|503|504)$/.test(error.message);
   if(!transient||attempt>=2)throw error;
   await wait(attempt===0?250:1000);
  }
 }
 function createLoader(fetchJSON,hash){
  const cache=new Map();
  return async c=>{
   if(!allowed(c)||!c.url)return null;
   const id=c.productId+':'+c.language+':'+c.url;
   if(!cache.has(id))cache.set(id,Promise.resolve().then(()=>fetchRetry(fetchJSON,c.url)).then(async d=>{
    if(d.schema_version!==1||d.product_id!==c.productId||d.locale!==c.language||d.handle!==c.handle||!Array.isArray(d.fields)||!Array.isArray(d.blockedReferences))throw Error('Bundle identity mismatch');
    const seen=new Set();
    for(const f of d.fields){
     if(seen.has(key(f))||f.held!==false||typeof f.source!=='string'||f.shopify_digest!==f.source_sha256||await hash(f.source)!==f.source_sha256)throw Error('Bundle source/digest guard failed');
     seen.add(key(f));
    }
    return d;
   }).catch(e=>{cache.delete(id);throw e;}));
   const d=await cache.get(id),blocked=new Set(d.blockedReferences),current=new Map(c.fields.map(f=>[key(f),f]));
   return {...d,fields:d.fields.filter(f=>{
    const actual=current.get(key(f));
    return !blocked.has(key(f))&&actual?.source_digest===f.source_sha256&&actual.expected_digest===f.shopify_digest;
   })};
  };
 }
 // Exact text-node substitution only; no HTML/attribute reconstruction or reverse guessing.
 function translateText(text,map){
  const leading=text.match(/^\s*/)[0],trailing=text.match(/\s*$/)[0],k=text.trim();
  if(Object.prototype.hasOwnProperty.call(map,k))return leading+map[k]+trailing;
  // metafield_tag may emit multiline values as individual lines or one text node.
  const parts=text.split(/(\r?\n)/);let changed=false;
  for(let i=0;i<parts.length;i+=2){const t=parts[i],x=t.trim();if(Object.prototype.hasOwnProperty.call(map,x)){parts[i]=t.match(/^\s*/)[0]+map[x]+t.match(/\s*$/)[0];changed=true;}}
  return changed?parts.join(''):null;
 }
 const api={allowed,createLoader,translateText,fetchRetry};
 if(typeof module!=='undefined'&&module.exports){module.exports=api;return;}
 if(root.PBCatalogRuntime)return;root.PBCatalogRuntime=api;
 const doc=root.document,records=new Map(),parents=new Map();let scheduled=false,activeLanguage=null;
 const language=()=>root.pbDraftLanguage?root.pbDraftLanguage():(doc.documentElement.lang||'de').split('-')[0];
 const hash=async s=>Array.from(new Uint8Array(await root.crypto.subtle.digest('SHA-256',new TextEncoder().encode(s)))).map(n=>n.toString(16).padStart(2,'0')).join('');
 const loader=createLoader(async url=>{const r=await root.fetch(url,{credentials:'same-origin'});if(!r.ok)throw Error('Bundle HTTP '+r.status);return r.json();},hash);
 function context(section,source){return {themeId:root.Shopify?.theme?.id,themeRole:root.Shopify?.theme?.role,pageType:'product',productId:section.dataset.productId,handle:source.handle,language:language(),url:source.urls?.[language()],fields:source.fields};}
 function areas(section,field){
  const result=Array.from(section.querySelectorAll('[data-pb-catalog-resource]')).filter(n=>n.dataset.pbCatalogResource===field.resource_id&&n.dataset.pbCatalogKey===field.resource_key);
  if(field.resource_key==='title'&&field.resource_id==='gid://shopify/Product/'+section.dataset.productId)result.push(...section.querySelectorAll('.product-single__title,.pb-product-heading-details'));
  if(field.resource_key==='body_html')result.push(...section.querySelectorAll('.pb-pdp-intro .pb-pdp-highlight, .pb-pdp-intro .pb-note'));
  return result;
 }
 function apply(section,bundle){
  const seen=new Set();
  for(const f of bundle.fields){
   if(f.preserve_identifier)continue;
   for(const area of areas(section,f)){
    const walker=doc.createTreeWalker(area,root.NodeFilter.SHOW_TEXT);let node;
    while((node=walker.nextNode())){
     if(seen.has(node))continue;
     const parent=node.parentElement;if(!parent||parent.closest('script,style,textarea,input,button,[data-pb-i18n],[data-sku],[data-pb-barcode]'))continue;
     const scope=parent.closest('[data-pb-catalog-resource]');
     if(scope&&(scope.dataset.pbCatalogResource!==f.resource_id||scope.dataset.pbCatalogKey!==f.resource_key))continue;
     seen.add(node);
     const record=records.get(node);
     if(record&&record.key!==key(f))continue;
     const original=record?.original??node.textContent;
     if(record&&node.textContent!==record.applied)continue; // external changes invalidate ownership
     const target=translateText(original,f.text_map);if(target===null)continue;
     if(!parents.has(parent))parents.set(parent,{lang:parent.getAttribute('lang'),wg:parent.getAttribute('data-wg-notranslate')});
     if(!record)records.set(node,{key:key(f),original,applied:target,parent,lang:parent.getAttribute('lang'),wg:parent.getAttribute('data-wg-notranslate')});else record.applied=target;
     if(node.textContent!==target)node.textContent=target;
     if(parent.lang!==bundle.locale)parent.lang=bundle.locale;
     if(parent.getAttribute('data-wg-notranslate')!=='true')parent.setAttribute('data-wg-notranslate','true');
    }
   }
  }
 }
 function restore(){
  for(const [node,r]of records)if(node.isConnected&&node.textContent===r.applied)node.textContent=r.original;
  for(const [parent,r]of parents)if(parent.isConnected)for(const [a,v]of [['lang',r.lang],['data-wg-notranslate',r.wg]]){if(v===null)parent.removeAttribute(a);else parent.setAttribute(a,v);}
  records.clear();parents.clear();
 }
 const states=new WeakMap();
 async function run(){
  if(activeLanguage!==language()){restore();activeLanguage=language();}
  if(!LANGS.includes(language())){restore();return;}
  for(const section of doc.querySelectorAll('.product-section[data-product-id]')){
   const script=section.querySelector('[data-pb-catalog-source]');if(!script)continue;
   let source;try{source=JSON.parse(script.textContent);}catch{continue;}
   const c=context(section,source);if(!allowed(c)||c.productId!==source.product_id)continue;
   const token=c.productId+':'+c.language+':'+script.textContent;
   let state=states.get(section);
   if(state?.token===token){if(state.bundle)apply(section,state.bundle);continue;}
   if(state)restore();
   state={token};states.set(section,state);
   try{
    const data=await loader(c);
    if(!section.isConnected||states.get(section)!==state||language()!==c.language||JSON.stringify(context(section,source))!==JSON.stringify(c))continue;
    state.bundle=data;if(data){apply(section,data);doc.dispatchEvent(new CustomEvent('pb:catalog-ready',{detail:{productId:c.productId,locale:c.language}}));}
   }catch(e){state.error=e.message;section.setAttribute('data-pb-catalog-error',e.message);}
  }
 }
 function schedule(){if(scheduled)return;scheduled=true;queueMicrotask(()=>{scheduled=false;run();});}
 function start(){new MutationObserver(schedule).observe(doc.documentElement,{subtree:true,childList:true,characterData:true});doc.addEventListener('pb:locale-change',schedule);root.addEventListener('popstate',schedule);schedule();}
 if(doc.readyState==='loading')doc.addEventListener('DOMContentLoaded',start,{once:true});else start();
})(typeof window==='undefined'?globalThis:window);
